var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewIconsCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M67.5,132.25c35.7241,0,64.75-29.0259,64.75-64.75S103.2241,2.75,67.5,2.75,2.75,31.7759,2.75,67.5s29.0259,64.75,64.75,64.75Z",
    style: {
      fill: "#00aa6c",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.647,43.6095H36.353c-4.1306,0-7.4797,3.3491-7.4797,7.4797v37.3987c0,4.1306,3.3491,7.4797,7.4797,7.4797h62.294c4.1306,0,7.4797-3.3491,7.4797-7.4797V51.0892c0-4.1306-3.3491-7.4797-7.4797-7.4797Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9634,43.6095v52.2465",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5164,34.6784h-14.8478v8.931h14.8478v-8.931h0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0603,69.7328c0-8.2612-6.6983-14.9595-14.9595-14.9595s-14.9595,6.6983-14.9595,14.9595,6.6983,14.9595,14.9595,14.9595,14.9595-6.6983,14.9595-14.9595Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.9629,51.7591h0c-1.6746,0-3.0142,1.3397-3.0142,3.0142h0c0,1.6746,1.3397,3.0142,3.0142,3.0142h0c1.6746,0,3.0142-1.3397,3.0142-3.0142h0c0-1.6746-1.3397-3.0142-3.0142-3.0142Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIconsCameraIcon);
export default __webpack_public_path__ + "static/media/new-icons_camera-icon.4be91009ff29ed1937ae85229f223d64.svg";
export { ForwardRef as ReactComponent };